import { useSelector } from 'react-redux';
import ContactZendeskAgent from '~/components/support/contact-zendesk-agent.js';
import ContactAdaAgent from '~/components/support/contact-ada-agent.js';

const ContactSupportAgent = ({
	department = '',
	chatTags = [],
	searchLabels = [],
	metaFields = {},
	className,
	callbackFunction,
	buttonText,
	buttonIcon
}) => {
	const support = useSelector(state => state.support);

	if (support.ada) {
		return (
			<ContactAdaAgent
				proactiveChatReason={chatTags}
				metaFields={metaFields}
				className={className}
				buttonText={buttonText}
				callbackFunction={callbackFunction}
				buttonIcon={buttonIcon}
			/>
		);
	}

	if (support.zendesk) {
		return (
			<ContactZendeskAgent
				department={department}
				chatTags={chatTags}
				searchLabels={searchLabels}
				className={className}
				callbackFunction={callbackFunction}
			/>
		);
	}

	return null;
};

export default ContactSupportAgent;
